import { LitElement } from 'lit'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { property, customElement } from 'lit/decorators.js'
import { ZapticReportTile } from '../../app-core/lib/ui/ZapticReportTile'

@customElement('zaptic-report-tile')
export class ReportTile extends LitElement {
    @property({ attribute: 'image-url', type: String })
    imageUrl: string

    @property({ attribute: 'title-text', type: String })
    titleText: string

    @property({ attribute: 'detail-text', type: String })
    detailText: string

    @property({ type: Boolean, converter: (_) => true })
    compact: boolean

    render() {
        return ReactDOM.render(
            <ZapticReportTile
                titleText={this.titleText}
                detailText={this.detailText}
                imageUrl={this.imageUrl}
                compact={this.compact}
            />,
            this
        )
    }

    protected createRenderRoot() {
        return this
    }
}
